/** @format */

import { TStore } from '@/redux/helpers/createStore';

export const selectorLoading = (store: TStore) => store.listing.loading;
export const selectorFilters = (store: TStore) => store.listing.filters;
export const selectorResults = (store: TStore) => store.listing.results;
export const selectorPageIndex = (store: TStore) => store.listing.pageIndex;
export const selectorOrderBy = (store: TStore) => store.listing.filters.orderBy;
export const selectorMonthlyPrice = (store: TStore) => store.listing.filters.monthlyPrice;
export const selectorPropertyType = (store: TStore) => store.listing.filters.propertyType;
export const selectorCheckInDate = (store: TStore) => store.listing.filters.checkInDate;
export const selectorPoi = (store: TStore) => store.listing.filters.positions;
export const selectorAreas = (store: TStore) => store.listing.filters.areas;
export const selectorListingQuery = (store: TStore) => store.listing.query;
export const selectorIsPoiUrlSet = (store: TStore) => store.listing.isPoiUrlSet;
export const selectSearchByMap = (store: TStore) => store.listing.searchByMap;
export const selectorCityName = (store: TStore) => store.listing.addressCenterMap || '';
